import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import {
  normalizeCoach,
  sortCoaches,
  staticCoachesAsDocs,
} from '../utils/coachesCatalog';

/**
 * Live coaches = Firestore `coaches` overlaid on the built-in list.
 * Soft-deleted docs (active === false) stay hidden and block static resurrection.
 */
export default function useCoachesCatalog() {
  const [coaches, setCoaches] = useState(() => staticCoachesAsDocs());
  const [source, setSource] = useState('static');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, 'coaches'),
      (snap) => {
        const staticDocs = staticCoachesAsDocs();
        if (snap.empty) {
          setCoaches(staticDocs);
          setSource('static');
          setLoading(false);
          return;
        }

        const fromFs = snap.docs.map((d) => normalizeCoach({ id: d.id, ...d.data() }));
        const presentIds = new Set(fromFs.map((c) => c.id));
        const activeFs = fromFs.filter((c) => c.active !== false);
        const fromStatic = staticDocs.filter((c) => !presentIds.has(c.id));
        const merged = sortCoaches([...activeFs, ...fromStatic]);

        setCoaches(merged);
        if (fromStatic.length === 0) setSource('firestore');
        else if (activeFs.length === 0) setSource('static');
        else setSource('hybrid');
        setLoading(false);
      },
      (err) => {
        console.error('coaches listen:', err);
        setCoaches(staticCoachesAsDocs());
        setSource('static');
        setLoading(false);
      }
    );
    return () => unsub();
  }, []);

  return { coaches, source, loading };
}
